import React, { useContext, useState, useEffect, useRef } from "react";
import logo from "../assets/img/logo2.svg";
import "../assets/css/argon-dashboard-react.css"
import {
  DropdownMenu,
  DropdownItem,
  UncontrolledDropdown,
  DropdownToggle,
  Nav,
  Media,
  Progress,
  Button,
  Modal,
  ModalBody,
} from "reactstrap";
import { Link, useLocation } from "react-router-dom";
import { Row, Col } from "reactstrap"
import "../assets/css/argon-dashboard-react.css";
import { useNavigate } from "react-router-dom";
import axiosInstance from "../apiHandles/axiosInstance";
import { UserProgressContext } from "../context/UserProgressContext";
import "../assets/css/commonHeader.css"
import { usePremium } from "context/PremiumProvider";
import "../assets/css/colors.css"
import { useLanguage } from "context/LanguageProvider";
import { useDarkMode } from "context/DarkModeProvider";
import { fetchIsTeacher } from "../apiHandles/user_progress.js";


const CommonHeader = () => {
  const { xp, level, isInitialized } = useContext(UserProgressContext);
  const navigate = useNavigate();
  const location = useLocation();
  const [showLevelUpModal, setShowLevelUpModal] = useState(false);
  const previousLevelRef = useRef(null);
  const { isPremium } = usePremium();
  const [isTeacher, setIsTeacher] = useState(null);

  useEffect(() => {
    const fetchTeacherStatus = async () => {
      const teacherStatus = await fetchIsTeacher();
      setIsTeacher(teacherStatus);
    };
    fetchTeacherStatus();
  }, []);

  const { selLanguage, toggleLanguage, isLoading } = useLanguage();
  const { darkMode } = useDarkMode();


  const hideDasaName = /index|MyProfile|quiz|flashcard|stage|Settings|description|Filed|premium|feedback|classDetails|games|custom-graph/i.test(location.pathname);

  // Check for level up
  useEffect(() => {
    if (!isInitialized) return;

    if (previousLevelRef.current !== null && level > previousLevelRef.current) {
      setShowLevelUpModal(true);
    }

    previousLevelRef.current = level;
  }, [level, isInitialized]);

  const handleLogout = () => {
    localStorage.removeItem("access");
    localStorage.removeItem("refresh");
    delete axiosInstance.defaults.headers.common["Authorization"];
    navigate("/login");
  };

  const handleMyProfile = () => {
    navigate("/admin/MyProfile");
  };

  useEffect(() => {

    if (!isInitialized) {
      return;
    }

    if (previousLevelRef.current === null) {
      previousLevelRef.current = level;
      return;
    }

    if (level > previousLevelRef.current) {
      setShowLevelUpModal(true);

      const timer = setTimeout(() => {
        setShowLevelUpModal(false);
      }, 5000);

      return () => clearTimeout(timer);
    }

    previousLevelRef.current = level;
  }, [level, isInitialized]);

  return (
    <>
      <header className="dasa-header" style={{ background: darkMode ? "#0f172a" : "#f4f3ef" }}>
        {/* Logo and DaSA text */}
        <div className="logo-button" style={{ background: darkMode ? "#0f172a" : "	#f4f3ef" }}>
          {!hideDasaName && (
            <Button
              className="dasa-button"
              onClick={() => {
                const mode = localStorage.getItem("homeMode");
                navigate("/Homepage/homepage", {
                  state: { isProgramming: mode === "programming" }
                });
              }}
              style={{
                outline: "none",
                boxShadow: "none",
              }}
            >
              <div className="dasa-button-content" style={{ display: "flex", alignItems: "center" }}>
                <img
                  src={logo}
                  alt="Logo"
                  style={{ height: "45px", marginRight: "10px" }}
                />
                DaSA
              </div>
            </Button>
          )}</div>

        {/* XP Level Progress Bar */}
        <div
          className="xp-container"
          style={{ background: darkMode ? "#1e293b" : "var(--lightModeXpContainer)" }}
        >
          <Col xs="6" sm="9" md="9" lg="10" xl="10">
            <div className="xp-insideItem-container">
              <div style={{
                display: "flex",
                alignItems: "center",
                flexWrap: "nowrap",
                whiteSpace: "nowrap",
              }}>
                <div
                  className="level-label"
                  style={{
                    marginLeft: { selLanguage: "10px" },
                    color: darkMode ? "#c4c4c4ff" : "#1b1b1bd5",
                  }}
                >
                  {selLanguage ? "Eπίπεδο" : "Level"} {level}
                </div>
                <div
                  className="xp-label"
                  style={{ color: darkMode ? "#c4c4c4ff" : "#1b1b1bd5" }}
                >
                  {xp} / {level * 100} XP
                </div>
              </div>
              <Progress
                value={((xp % (level * 100)) * 100) / (level * 100)} color="primary"
                style={{
                  height: "8px",
                  borderRadius: "5px",
                  margin: "0 auto",
                  flex: 1,
                  backgroundColor: "lightgray",
                  minWidth: "150px",
                  overflow: "hidden",
                  ...(isTeacher && { marginRight: "23px" }),
                }}
                barStyle={{
                  background: "linear-gradient(to right, rgb(94, 114, 228), rgb(108, 52, 131))",
                  borderRadius: "5px",
                }}
              />
            </div>
          </Col>

          {/* User Profile Dropdown + Teacher Class Button */}
          <Col xs="6" sm="3" md="3" lg="3" xl="3">
            <Nav className="header-actions-nav" navbar style={{
              flexShrink: 0,
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: isTeacher ? "flex-end" : "center",
              gap: "10px",
              paddingRight: isTeacher ? "8px" : "0",
            }}>

              {/* Teacher Class Circle Button */}
              {isTeacher && (
                <div
                  className="teacherButton"
                  onClick={() => navigate("/admin/classDetails")}
                  title={selLanguage ? "Τάξη" : "Class"}
                  style={{
                    background: darkMode ? "#e1e1e1" : "lightgray",
                  }}
                  onMouseEnter={e => {
                    e.currentTarget.style.transform = "translateY(-1px)";
                    e.currentTarget.style.boxShadow = "0 4px 12px rgba(255, 255, 255, 0.4)";
                  }}
                  onMouseLeave={e => {
                    e.currentTarget.style.transform = "translateY(0)";
                    e.currentTarget.style.boxShadow = "none";
                  }}
                >
                  <i
                    className="ni ni-hat-3"
                    style={{ fontSize: "18px", color: "#5e72e4" }}
                  />
                </div>
              )}

              {/* Profile Avatar Dropdown */}
              <UncontrolledDropdown nav>
                <DropdownToggle style={{ display: "flex", alignItems: "center", justifyContent: "center", padding: 0 }} nav>
                  <Media>
                    <span
                      className={`avatar rounded-circle d-flex align-items-center justify-content-center avatar-background ${isTeacher ? "avatar-teacher" : "avatar-normal"}`}
                      style={{
                        outline: isPremium ? "2px solid #20bde0ff" : "none",
                        background: darkMode ? "#e1e1e1" : "lightgray",
                        outlineOffset: isPremium ? "2px" : "0",
                      }}
                    >
                      <i
                        className="ni ni-single-02"
                        style={{ fontSize: isTeacher ? "16px" : "20px", color: "#5e72e4" }}
                      />
                    </span>
                  </Media>
                </DropdownToggle>
                <DropdownMenu className="dropdown-menu-arrow" right style={{ background: darkMode ? "#1E293BFA" : "#fffafaff" }}>
                  <DropdownItem
                    style={{ background: darkMode ? "#202c3dfa" : "#fffafaff" }}
                    onClick={handleMyProfile}>
                    <i style={{ color: darkMode ? "#fdfdfdf8" : "#070808ff" }} className="ni ni-single-02" />
                    <span style={{ color: darkMode ? "#fdfdfdf8" : "#070808ff" }}>
                      {selLanguage ? "Το προφίλ μου" : "My profile"}
                    </span>
                  </DropdownItem>

                  <DropdownItem style={{ borderColor: darkMode ? "#e9e9e9fa" : "#5c5c5cff" }} divider />

                  <DropdownItem
                    style={{ background: darkMode ? "#202c3dfa" : "#fffafaff" }}
                    onClick={() => {
                      navigate("/admin/premium");
                    }}
                  >
                    <i style={{ color: darkMode ? "#f0f0f0ff" : "#070808ff" }} className="ni ni-diamond" />
                    <span style={{ color: darkMode ? "#f0f0f0ff" : "#070808ff" }}> Premium</span>
                  </DropdownItem>

                  <DropdownItem style={{ borderColor: darkMode ? "#e9e9e9fa" : "#5c5c5cff" }} divider />

                  <DropdownItem
                    style={{ background: darkMode ? "#202c3dfa" : "#fffafaff" }}
                    href="#pablo"
                    onClick={() => {
                      navigate("/admin/feedback");
                    }}
                  >
                    <i style={{ color: darkMode ? "#fdfdfdf8" : "#070808ff" }} className="ni ni-single-copy-04" />
                    <span style={{ color: darkMode ? "#fdfdfdf8" : "#070808ff" }}>
                      {selLanguage ? "Ανατροφοδότηση" : "  Feedback"}
                    </span>
                  </DropdownItem>

                  <DropdownItem style={{ borderColor: darkMode ? "#e9e9e9fa" : "#5c5c5cff" }} divider />

                  <DropdownItem
                    style={{ background: darkMode ? "#202c3dfa" : "#fffafaff" }}
                    href="#pablo"
                    onClick={handleLogout}
                  >
                    <i style={{ color: darkMode ? "#fdfdfdf8" : "#070808ff" }} className="ni ni-user-run" />
                    <span style={{ color: darkMode ? "#fdfdfdf8" : "#070808ff" }}>
                      {selLanguage ? "Αποσύνδεση" : "  Logout"}
                    </span>
                  </DropdownItem>
                </DropdownMenu>
              </UncontrolledDropdown>
            </Nav>
          </Col>
        </div>
      </header >

      {/* Level Up Modal */}
      <Modal
        isOpen={showLevelUpModal}
        centered
        contentClassName="level-up-modal"
        keyboard={false}
        size="lg"
        style={{
          background: "none"
        }}
      >
        <ModalBody
          className="level-up-modal-body"
          style={{
            background: "none",
            boxShadow: "none"
          }}
        >
          <div
            className="level-up-content"
            style={{
              background: darkMode ? "linear-gradient(135deg, #1e293b 0%, #334155 100%);" : "var(--lightModeModal)"
            }}
          >
            {/* Celebration particles */}
            <div className="particles-container">
              {[...Array(20)].map((_, i) => (
                <div
                  key={i}
                  className="particle"
                  style={{
                    animationDelay: `${Math.random() * 2}s`,
                    left: `${Math.random() * 100}%`
                  }}
                ></div>
              ))}
            </div>

            {/* Main content */}
            <div className="level-up-main">
              <h1 className="level-up-title">
                {selLanguage ? "ΣΥΓΧΑΡΗΤΗΡΙΑ!" : "CONGRATULATIONS!"}
              </h1>

              <div className="level-up-badge">
                <div className="level-badge-shine"></div>
                <span className="level-number">
                  LEVEL {level}
                </span>
              </div>

              <p
                className="level-up-message"
                style={{
                  color: darkMode ? "#fff" : "#161515ff"
                }}
              >
                {selLanguage ? "Έφτασες στο επόμενο επίπεδο!" : "You reached the next level"}<br />
                {selLanguage ? "Συνέχισε έτσι!" : "Keep up the good work!"}
              </p>

              <Button
                className="level-up-continue-btn"
                onClick={() => setShowLevelUpModal(false)}
              >
                {selLanguage ? "Συνέχισε" : "Continue"}
              </Button>
            </div>
          </div>
        </ModalBody>
      </Modal>
    </>
  );
};

export default CommonHeader;